<template>
  <div>
    <!-- Original ItemList content -->
    <div class="row" v-for="(item, index) in items" :key="index">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-error': errors.item_code }">
          <label for="item_code">Item Code</label>
          <input 
            type="text" 
            readonly 
            class="form-control" 
            id="item_code" 
            name="item_code" 
            aria-describedby="tpitem_code"
            placeholder="Item Code" 
            autocomplete="on" 
            :value="item.item_code"
          >
          <label v-if="errors.item_code" for="item_code" class="error">{{ errors.item_code }}</label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-error': errors[`item_barcode.${index}`] }">
          <label :for="`item_barcode_${index}`">Bar Code</label>
          <input 
            type="text" 
            class="form-control" 
            :id="`item_barcode_${index}`" 
            :name="`barcode_${item.item_code.replace(/-/g, '_')}`"
            aria-describedby="tpitem_barcode"
            placeholder="Bar Code" 
            autocomplete="on" 
            readonly
            :value="item.item_barcode"
          >
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-error': errors.item_photo }">
          <label for="item_photo">Photo</label>
          <br>
          <img 
            v-if="item.item_photo === '' || !item.item_photo"
            class="img img-fluid" 
            src="/img/no-image-png-5-Transparent-Images.png"
            alt="No image available"
          >
          <img 
            v-else
            class="img img-fluid" 
            :src="`data:image/png;base64,${item.item_photo}`"
            alt="Item photo"
          >
        </div>
      </div>
    </div>
    
    <!-- SerialNumberNew component content -->
    <section>
      <input
        type="hidden"
        class="form-control"
        :name="`incremental`"
        id="incremental"
        aria-describedby="tpincremental"
        v-model="incremental"
      />
      <div class="custom-control custom-switch pb-3">
        <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="incremental">
        <label class="custom-control-label" for="customSwitch1">Incremental</label>
      </div>
      <div class="row pb-3" v-if="incremental">
        <div class="col-md-12">
          <div class="form-row" v-for="(incremental,index) in incrementals" :key="`incremental-${index}`">
            <div class="form-group col-md-2">
              <label for="prefix">Prefix</label>
              <input type="text" :name="`incrementals[${index}][prefix]`" class="form-control" placeholder="The starting characters" v-model="incremental.prefix">
            </div>
            <div class="form-group col-md-3">
              <label for="starting">Starting Number</label>
              <input @change="validateForm(index)" type="number" required :name="`incrementals[${index}][starting]`" class="form-control" placeholder="Starting Number" v-model="incremental.starting" >
            </div>
            <div class="form-group col-md-3">
              <label for="ending">Ending Number</label>
              <input @change="validateForm(index)" type="number" required :name="`incrementals[${index}][ending]`" class="form-control" placeholder="Ending Number" v-model="incremental.ending">
              <small v-if="incremental.starting != '' && incremental.ending == ''">Please key in valid ending number</small>
              <small v-else-if="incremental.starting > incremental.ending">Please key in starting number smaller than ending number</small>
            </div>
            <div class="form-group col-md-2">
              <label for="suffix">Suffix</label>
              <input type="text" :name="`incrementals[${index}][suffix]`" class="form-control" placeholder="The end characters" v-model="incremental.suffix">
            </div>
            <div class="form-group col-md-2">
              <button @click="addItem" class="add-btn btn btn-primary" type="button"> + </button>
              <button @click="removeItem(index)" class="remove-btn btn btn-danger" type="button"> - </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row pb-3" v-else>
        <div class="col-md-7">
          <div class="form-group">
            <label for="item_description">Item Serial Number</label>
            <multiselect
              v-model="item_serial_numbers_select"
              tag-placeholder="Choose this as the serial number"
              placeholder="Search or add a serial number"
              label="serial_number"
              track-by="serial_number"
              :options="serialnumbers"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
              @select="updateModel"
              @remove="removeVal"
            ></multiselect>
            <input
              type="hidden"
              class="form-control"
              :name="`item_serial_number[]`"
              aria-describedby="tpitem_description"
              v-model="item_serial_numbers"
            />
          </div>
        </div>
        <div class="col-md-3 col-sm-12" v-if="isMobile()">
          <div class="mb-3">
            <button 
              @click="toggleCamera" 
              class="btn btn-success btn-block"
              type="button"
            >
              <i class="fas fa-camera"></i> 
              {{ cameraActive ? 'Stop Camera' : 'Start Camera' }}
            </button>
          </div>
          <div id="qr-code-full-region" v-show="cameraActive"></div>
        </div>
        <div class="col-md-3 col-sm-12" v-else>
          <div class="mb-3">
            <button 
              @click="startQRCodeScanning" 
              class="btn btn-block mb-2"
              :class="cameraActive ? 'btn-success' : 'btn-primary'"
              type="button"
            >
              <i class="fas fa-qrcode"></i> 
              {{ cameraActive ? 'QR Camera Active' : 'Scan QR Code (Serial Number)' }}
            </button>
            <button 
              @click="stopCamera" 
              class="btn btn-danger btn-block"
              type="button"
              v-if="cameraActive"
            >
              <i class="fas fa-stop"></i> 
              Stop Camera
            </button>
          </div>
          <div id="qr-code-full-region" v-show="cameraActive"></div>
        </div>
      </div>
      <div
        v-for="(msg, index) in message"
        :key="index"
        style="white-space: pre-line"
      >
        <pre>decodedResult => {{ msg.decodedResult }}</pre>
      </div>
    </section>
  </div>
</template>

<script>
import { Html5QrcodeScanner } from "html5-qrcode";
// To use Html5Qrcode (more info below)
import {Html5Qrcode, Html5QrcodeSupportedFormats} from "html5-qrcode"
import cameraManager from '../services/CameraManager.js'
export default {
  name: 'ItemList',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    serialnumbers: {
      type: Array,
      default: () => []
    },
    orderitems: {
      type: Array,
      default: () => []
    },
    itemcode: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      incremental: false,
      value: "",
      countries: [],
      packages: [],
      options: [],
      item_serial_numbers: [],
      item_serial_numbers_select: [],
      isLoading: false,
      item_type: 'type',
      search_term: "",
      scanned: false,
      message: [],
      incrementals: [],
      cameraActive: false,
      html5QrCode: null,
      scanningMode: 'qr', // 'qr' or 'barcode'
      localItems: [],
      activeBarcodeCamera: null,
      barcodeHtml5QrCode: null
    };
  },
  mounted() {
    console.log("Component mounted.");
    console.log(this.items);
    this.countries = [...this.itemcode];
    this.localItems = [...(this.orderitems.length ? this.orderitems : this.items)];
    // Register with camera manager
    cameraManager.register(this);
    // this.refreshScanner();
    if (!this.isMobile()) {
      this.creatScan();
    }
    this.addItem();
  },
  beforeDestroy() {
    // Clean up cameras and unregister from manager
    this.stopCamera();
    this.stopBarcodeCamera();
    cameraManager.unregister(this);
  },
  methods: {
    validateForm(index){
      if(this.incrementals[index].starting > this.incrementals[index].ending || (incremental.starting != '' && incremental.ending == '')){
        $('#submit').prop("disabled",true);
      }else{
        $('#submit').prop("disabled",false);
      }
    },
    addItem() {
      this.incrementals.push({
        prefix: "",
        suffix: "",
        starting: "",
        ending: "",
      });
    },
    removeItem(index) {
      this.incrementals.splice(index, 1);
    },
    toggleCamera() {
      if (this.cameraActive) {
        this.stopCamera();
      } else {
        this.startCamera();
      }
    },
    startCamera() {
      // Request camera access (this will automatically stop other cameras)
      cameraManager.requestCamera(this, 'ItemList');
      
      this.cameraActive = true;
      this.$nextTick(() => {
        this.creatScan();
      });
    },
    stopCamera() {
      if (this.html5QrCode) {
        this.html5QrCode.stop().then(() => {
          this.cameraActive = false;
          this.html5QrCode = null;
          // Release camera from manager
          cameraManager.releaseCamera(this);
        }).catch((err) => {
          console.log(err);
          this.cameraActive = false;
          this.html5QrCode = null;
          // Release camera from manager even on error
          cameraManager.releaseCamera(this);
        });
      } else {
        this.cameraActive = false;
        // Release camera from manager
        cameraManager.releaseCamera(this);
      }
    },
    // Handle camera state changes from other components
    onCameraStateChanged(activeComponent, componentName) {
      if (activeComponent !== this && (this.cameraActive || this.activeBarcodeCamera !== null)) {
        console.log(`Camera taken by ${componentName}, stopping ItemList cameras`);
        this.stopCamera();
        this.stopBarcodeCamera();
      }
    },
    startBarcodeScanning(itemIndex) {
      // Stop any existing cameras first
      this.stopCamera();
      
      // If there's an active barcode camera, stop it first and wait
      if (this.barcodeHtml5QrCode) {
        this.barcodeHtml5QrCode.stop().then(() => {
          this.barcodeHtml5QrCode = null;
          this.startNewBarcodeCamera(itemIndex);
        }).catch((err) => {
          console.log(err);
          this.barcodeHtml5QrCode = null;
          this.startNewBarcodeCamera(itemIndex);
        });
      } else {
        this.startNewBarcodeCamera(itemIndex);
      }
    },
    
    startNewBarcodeCamera(itemIndex) {
      // Request camera access through camera manager
      cameraManager.requestCamera(this, `ItemList-Barcode-${itemIndex}`);
      
      this.activeBarcodeCamera = itemIndex;
      this.$nextTick(() => {
        this.createBarcodeScan(itemIndex);
      });
    },
    
    stopBarcodeCamera() {
      if (this.barcodeHtml5QrCode) {
        this.barcodeHtml5QrCode.stop().then(() => {
          this.activeBarcodeCamera = null;
          this.barcodeHtml5QrCode = null;
          cameraManager.releaseCamera(this);
        }).catch((err) => {
          console.log(err);
          this.activeBarcodeCamera = null;
          this.barcodeHtml5QrCode = null;
          cameraManager.releaseCamera(this);
        });
      } else {
        this.activeBarcodeCamera = null;
        cameraManager.releaseCamera(this);
      }
    },
    
    createBarcodeScan(itemIndex) {
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          this.barcodeHtml5QrCode = new Html5Qrcode(`barcode-camera-${itemIndex}`, true);
          
          const config = {
            fps: 10,
            qrbox: 250,
            aspectRatio: 2,
            supportedScanTypes: ['SCAN_TYPE_CAMERA'],
            formatsToSupport: [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.UPC_A,
              Html5QrcodeSupportedFormats.UPC_E
            ]
          };
          
          this.barcodeHtml5QrCode.start(
            { facingMode: { exact: "environment"} },
            config,
            (decodedText, decodedResult) => {
              // Set the barcode value to the specific item
              this.items[itemIndex].item_barcode = decodedText;
              
              // Play beep sound
              var audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3');
              audio.play();
              
              // Stop the camera after successful scan
              this.stopBarcodeCamera();
            },
            (errorMessage) => {
              // Ignore scan errors
            }
          ).catch((err) => {
            console.log(err);
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    startQRCodeScanning() {
      this.scanningMode = 'qr';
      this.startCamera();
    },
    creatScan() {
      // This method will trigger user permissions
      Html5Qrcode.getCameras().then(devices => {
        /**
         * devices would be an array of objects of type:
         * { id: "id", label: "label" }
         */
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          this.html5QrCode = new Html5Qrcode(/* element id */ "qr-code-full-region", /* verbose= */ true);
          
          // Configure scanning based on mode
          const config = {
            fps: 10,
            qrbox: 250,
            aspectRatio: 2,
          };
          
          // Add barcode format support if scanning barcodes
          if (this.scanningMode === 'barcode') {
            config.supportedScanTypes = [
              'SCAN_TYPE_CAMERA'
            ];
            config.formatsToSupport = [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.UPC_A,
              Html5QrcodeSupportedFormats.UPC_E
            ];
          }
          
          this.html5QrCode.start(
            { facingMode: { exact: "environment"} },
            config,
            (decodedText, decodedResult) => {
              // console.log(decodedText)
              // console.log(decodedResult)
              this.addTag(decodedText)
              // do something when code is read
            },
            (errorMessage) => {
              // alert(errorMessage)
              // console.log(errorMessage)
              // parse error, ignore it.
            }
          ).catch((err) => {
            console.log(err)
            // Start failed, handle it.
          });
        }
      }).catch(err => {
        console.log(err)
        // handle err
      });
    },
    onScanSuccess(decodedText, decodedResult) {
      this.scanSuccessFile(decodedText)
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    refreshScanner(){
      var html5QrcodeScanner = new Html5QrcodeScanner(
            "qr-reader", { fps: 10, qrbox: { width: 400, height: 250 },experimentalFeatures: {useBarCodeDetectorIfSupported: true}, });
        html5QrcodeScanner.render(onScanSuccess);
        var that = this
        html5QrcodeScanner.applyVideoConstraints({ focusMode: "continuous", advanced: [ {zoom: isAndroid ? 1.5 : 2.0 } ]})
        function onScanSuccess(decodedText, decodedResult) {
          console.log(`Code scanned = ${decodedText}`, decodedResult);
          that.scanSuccessFile(decodedText)
        }
    },
    scanSuccessFile(decodedText){
      this.scanned = true
      this.addTag(decodedText)
    },
    removeVal(tag){
      console.log(tag)
      const index = this.item_serial_numbers.indexOf(tag.serial_number);
      if (index > -1) {
        this.item_serial_numbers.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    updateModel(newTag){
      this.item_serial_numbers.push(newTag.serial_number)
      this.serialnumbers.push(newTag)
    },
    addTag (newTag) {
      const tag = {
        serial_number: newTag,
        item_code: '',
      }
      var exist = false;
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        if(this.item_serial_numbers_select[index].serial_number == newTag){
          exist = true
        }
      }
      if(!exist){
        if(this.scanned){
          var audio = new Audio('/audio/Barcode-scanner-beep-sound.mp3'); // path to file
          audio.play();
          this.scanned = false
        }
        this.serialnumbers.push(tag)
        this.item_serial_numbers_select.push(tag)
        this.item_serial_numbers.push(newTag)
      }else{
        // alert('Serial Number already chosen')
      }
      this.refreshScanner()
    },
    setSerialNoVal(){
      this.item_serial_numbers = ''
      for (let index = 0; index < this.item_serial_numbers_select.length; index++) {
        this.item_serial_numbers += this.item_serial_numbers_select[index].serial_number+', '
      }
    },
    limitText(count) {
      return `and ${count} other countries`;
    },
    asyncFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.countries = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    asyncPackageFind(query) {
      this.search_term = query;
      if (query && query != "") {
        this.isLoading = true;
        axios
          .get("/ajax/search-ac-package?parameter=" + query)
          .then((response) => {
            if (this.search_term == response.data.search_term) {
              this.packages = response.data.data;
              this.isLoading = false;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    clearAll() {
      this.selectedCountries = [];
    },
    packageQtyChange(index1) {
      if (this.localItems[index1].package_items) {
        for (
          let index = 0;
          index < this.localItems[index1].package_items.length;
          index++
        ) {
          this.localItems[index1].package_items[index].item_quantity = this.localItems[
            index1
          ].package_items[index].item_quantity
            ? this.localItems[index1].package_items[index].item_quantity *
              this.localItems[index1].quantity
            : "";
        }
      }
    },
    setItemVal() {
      this.countries = [];
    },
    setPackageVal(item) {
      this.packages = [];
      if (item && item.package_code && item.package_code.package_dockey != "") {
        this.isLoading = true;
        var search = item.package_code.package_dockey;
        axios
          .get("/ajax/search-ac-package-item?parameter=" + search)
          .then((response) => {
            for (let index = 0; index < item.package_items.length; index++) {
              item[index1].package_items[index].item_quantity = item
                .package_items[index].item_quantity
                ? item.package_items[index].item_quantity * item.quantity
                : "";
            }
            item.package_items = response.data.data;
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    retrieveItemCode() {
      axios
        .get("/ajax/search-ac?parameter=" + this.localItems[index].item_code)
        .then(({ data }) => {
          var a = [];
          for (var i = 0; i < data.length; i++) {
            var temp = { value: data[i]["id"], name: data[i]["name"] };
            a.push(temp);
          }
          this.customers = a;
        });
    },
  }
}
</script>

<style scoped>
.has-error .form-control {
  border-color: #e74c3c;
}

.error {
  color: #e74c3c;
  font-size: 0.875em;
  margin-top: 0.25rem;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>